import React from 'react'

import Message from 'components/text/Message/Message'

import s from './SidebarTitle.scss'


const SidebarTitle = ({ title }) => (
  <Message className={s.title} tag="div" text={title} />
)


export default SidebarTitle
